"use client";

import React from "react";
import { ArrowRight, Eye } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const products = [{
  id: "prod-1",
  title: "Primary Care Services",
  description: "Expert medical management for your long-term health, wellness, and preventive screenings.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638797/img/suplementos_vitaminicos_premium.png"
}, {
  id: "prod-2",
  title: "Urgent Walk-In Care",
  description: "Fast, professional treatment for non-life-threatening illnesses and minor injuries when you need it most.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638797/img/image_zx39r2z4.webp"
}, {
  id: "prod-3",
  title: "Diagnostic Solutions",
  description: "Precise on-site lab testing and diagnostic imaging to ensure accurate and timely treatment plans.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638797/img/remedios_naturales_herbolaria.png"
}];
export default function NuestraSeleccion() {
  return <section data-section-id="223087" id="comprehensive-medical-support" className="bg-background py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-primary mb-4 tracking-tight">
            Comprehensive Medical Support
          </h2>
          <Separator className="w-24 mx-auto bg-ring h-1 rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, i) => <div key={product.id} data-index={i} className="group relative h-full">
              <Card className="rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden border-border/60 h-full flex flex-col bg-card">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={16 / 9}>
                    <img src={product.image} alt={product.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" />
                  </AspectRatio>
                  
                  {}
                  <div className="absolute inset-0 bg-primary/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <Button variant="secondary" asChild className="rounded-full shadow-lg bg-ring text-white hover:bg-ring/90 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 ease-out">
                      <Link to="https://polmedprimarycare.com/services/">
                        <Eye className="w-4 h-4 mr-2" />
                        Learn More
                      </Link>
                    </Button>
                  </div>
                </div>
                
                <CardHeader className="flex-grow pt-6 pb-8">
                  <CardTitle className="font-default font-bold text-xl text-primary mb-2">
                    {product.title}
                  </CardTitle>
                  <CardDescription className="font-default text-muted-foreground text-sm leading-relaxed">
                    {product.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>)}
        </div>

        <div className="mt-20 flex flex-col items-center">
          <Separator className="w-full max-w-md mb-8 bg-border/40" />
          <Link to="https://polmedprimarycare.com/contact-us/" className="inline-flex items-center text-ring font-default font-semibold text-lg hover:text-ring/80 transition-colors group">
            Schedule Your Consultation
            <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1.5 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>;
}